import dayjs from "dayjs";

/**
 * Checks if a date string is valid in the DD-MM-YYYY format.
 * @param {string} dateString - The date string to validate.
 * @returns {boolean} - Returns true if the date is valid, false otherwise.
 */
export const isValidDateDDMMYYYY = (dateString) => {
  return dayjs(dateString, "DD-MM-YYYY", true).isValid();
};
